export default {"src":"/_next/static/media/credit-score.9e14c52f.svg","height":108,"width":204};